// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductPreviousPurchase from "@plumberssupply/App/Components/Product/ProductPreviousPurchase";
import Tooltip, { TooltipPresentationProps } from "@plumberssupply/MobiusOverrides/Tooltip";
import Help from "@plumberssupply/XDL/Icons/Help";
import IconSaved from "@plumberssupply/XDL/Icons/IconSaved";
import IconSingleUse from "@plumberssupply/XDL/Icons/IconSingleUse";
import { mergeWithCss } from "@plumberssupply/XDL/Utilities";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    onChange: (isSingleUse: boolean) => void;
    isSingleUse?: boolean;
    extendedStyles?: SingleUseWishListCheckboxStyles;
}

export interface SingleUseWishListCheckboxStyles {
    wrapper?: InjectableCss;
    checkbox?: CheckboxPresentationProps;
}

const singleUseWishListCheckboxStyles: SingleUseWishListCheckboxStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            gap: 4px;
            margin-top: 15px;
        `,
    },
};

const SingleUseWishListCheckbox: FC<OwnProps> = ({ onChange, isSingleUse, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(singleUseWishListCheckboxStyles, extendedStyles));
    return (
        <StyledWrapper {...styles.wrapper}>
            <Checkbox
                variant="toggle"
                onChange={(ev, value) => {
                    onChange(value);
                }}
                checked={isSingleUse}
            >
                {translate(isSingleUse ? "Single Use" : "Saved")}
            </Checkbox>
            <Tooltip
                text={
                    isSingleUse
                        ? siteMessage("Custom_Cart_SingleUse_Checkbox")
                        : siteMessage("Custom_Cart_Saved_Checkbox")
                }
                iconProps={{
                    src: isSingleUse ? IconSingleUse : IconSaved,
                }}
            />
        </StyledWrapper>
    );
};

export default SingleUseWishListCheckbox;
